var mecklenburgVorpommernQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Mecklenburg-Vorpommern?',
    image: '371',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Mecklenburg-Vorpommern?',
    answers: [
      {
        content: 'Prignitz',
        key: 0,
      },
      {
        content: 'Demmin',
        key: 1,
      },
      {
        content: 'Vogtlandkreis',
        key: 0,
      },
      {
        content: 'Rhein-Sieg-Kreis',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Mecklenburg-Vorpommern gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Mecklenburg-Vorpommern bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Mecklenburg-Vorpommern?',
    answers: [
      {
        content: 'schwarz-rot-gold',
        key: 0,
      },
      {
        content: 'blau-weiß-gelb-rot',
        key: 1,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
      {
        content: 'schwarz-gelb',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Mecklenburg-Vorpommern über politische Themen informieren?',
    answers: [
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Mecklenburg-Vorpommern heißt...',
    answers: [
      {
        content: 'Greifswald.',
        key: 0,
      },
      {
        content: 'Schwerin.',
        key: 1,
      },
      {
        content: 'Rostock.',
        key: 0,
      },
      {
        content: 'Wismar.',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Mecklenburg-Vorpommern?',
    image: '378',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Mecklenburg-Vorpommern?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Mecklenburg-Vorpommern nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Mecklenburg-Vorpommern',
  },
]

export default mecklenburgVorpommernQuestions
